import * as AdditionalServiceStyles from './components/AdditionalService.css';

export default {
	AdditionalServiceStyles
};
